import styled from 'styled-components';

const Content = styled('div')`
  position: relative;
  width: 100%;
  padding: 16px 32px;
  background-color: #fff;
  border-radius: 24px 0 0 24px;
`;

export default Content;
